import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';

export function encryptDecrypt(password, keyPass) {
     var key = keyPass.split("");
    var output = [];
  
    for (var i = 0; i < password.length; i++) {
      var charCode = password.charCodeAt(i) ^ key[i % key.length].charCodeAt(0);
      output.push(String.fromCharCode(charCode));
    }
    return output.join("");
}


export function encodeBase64(data){
  return Buffer.from(data).toString('base64');
}

export function getDataUser(){
  return JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('user'),'8f6391895c404ab68eb7a8e42eb73587').toString(CryptoJS.enc.Utf8));
}

export function getIdUser(){
  return Number(Buffer.from(getDataUser().idUsuario, 'base64').toString('ascii'))
}